import { Buffer } from 'buffer';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from '@/shared/components/feedback/ErrorBoundary';
import App from './app/App';
import '@/styles/globals.css';
import '@/styles/zinc-theme.css';

if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = Buffer;
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
